<template>
  <!-- 错题排行 -->
  <div class="wrongSubject">
    <!-- 下拉框 -->
    <div class="selectInp">
      <el-select v-model="value1" placeholder="请选择">
        <el-option-group v-for="group in options1" :key="group.label" :label="group.label">
          <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-option-group>

      </el-select>
      <el-select v-model="value2" placeholder="请选择">
        <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <!-- 错题排行tab切换 -->
    <div class="cuotiTab">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
        <el-menu-item index="1">今日错题排行</el-menu-item>
        <el-menu-item index="2">全部错题排行</el-menu-item>
        <el-menu-item index="3">模考错题排行</el-menu-item>
      </el-menu>
    </div>
    <div class="cuotiTable">
      <el-table
          :data="tableData"
          border
          style="width: 100%">
          <el-table-column
            prop="date"
            label="科目课程"
            width="180">
          </el-table-column>
          <el-table-column
            prop="name"
            label="所属考点"
            width="180">
          </el-table-column>
          <el-table-column
            prop="address"
            label="类型">
          </el-table-column>
          <el-table-column
            prop="address"
            label="题干">
          </el-table-column>
          <el-table-column
            prop="address"
            label="答案">
          </el-table-column>
          <el-table-column
            prop="address"
            label="正确率"
            sortable
            width="90"
            >
          </el-table-column>
        </el-table>
        <div class="cuotiTable_bottom">
          <!-- 分页器 -->
          <el-pagination
            small
            layout="prev, pager, next"
            :total="50">
          </el-pagination>
          <el-input class="pageInp" v-model="page"></el-input>
          <span><span class="jump">跳转</span>&nbsp;&nbsp;共56条</span>
          <el-select class="pageItem" v-model="value" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
        </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        options1: [{
          label: '热门城市',
          options: [{
            value: 'Shanghai',
            label: '上海'
          }, {
            value: 'Beijing',
            label: '北京'
          }]
        }, {
          label: '城市名',
          options: [{
            value: 'Chengdu',
            label: '成都'
          }, {
            value: 'Shenzhen',
            label: '深圳'
          }, {
            value: 'Guangzhou',
            label: '广州'
          }, {
            value: 'Dalian',
            label: '大连'
          }]
        }],
        value1: '上海',
        options2: [{
          value: '经济法基础',
          label: '经济法基础'
        }, {
          value: '初级会计实务',
          label: '初级会计实务'
        }],
        value2: '经济法基础',
        activeIndex:'1',
        tableData:[],
        page:''
      }
    }
  }
</script>

<style lang='less'>
  .wrongSubject {
    background: white;
    padding-bottom: 100px;
    .selectInp {
      padding: 15px;
      .el-select {
        margin-right: 20px;
      }
    }
    .cuotiTable{
      width: 96%;
      margin: 20px auto 0;
    }

    .cuotiTable_bottom{
      margin: 10px 0 0 0;
      .el-pagination{
        float: left;
        button{
          border: 1px solid black;
          padding: 5px;
          margin-right: 2px;
        }
        .el-pager li{
            border: 1px solid !important;
            line-height: 20px;
            margin-right: 2px;
            padding: 0;
        }
      }
      .pageInp{
        margin: 2px 0 0 0;
        width: 50px;
        float: left;
        display: block;
        .el-input__inner{
          height: 22px;
          border-radius: 0;
        }
      }
      span{
        line-height: 22px;
        margin-left: 10px;
        float: left;
      }
      .jump{
        color: #409EFF;
      }
      .pageItem{
        width: 90px;
        margin-right: 10px;
        padding-left: 10px;
        .el-input__inner{
          height: 22px;
          line-height: 22px;
          border-radius: 0;
        }
        .el-input__icon{
           line-height: 22px;
        }
      }
    }

  }
  .el-select-group__wrap:not(:last-of-type)::after {
    display: none !important;
  }
  .el-select-group__wrap:not(:last-of-type) {
    padding-bottom: 0px;
  }

</style>



// WEBPACK FOOTER //
// src/components/wrongSubject/index.vue